module.exports = __webpack_public_path__ + "static/media/Logo lonaci new.de38a13c.png";